const useLoginInitialStates = () => {
    return {
        loginInitialState: {}
    };
}

export default useLoginInitialStates;